import React from 'react';
import PropTypes from 'prop-types';
import CurrentRoleStore from '../../stores/CurrentRoleStore';

const MESSAGE_MAP = {
  DEFAULT: "你没有权限访问此页面"
  // TODO: add more message types here
}

export default class UnauthorizedPage extends React.Component {
  static propTypes = {
  };

  constructor(props) {
    super(props);
    let messageType = 'DEFAULT';
    if (props.location.query.message)
      messageType = props.location.query.message
    // set state
    this.state = {
      message: MESSAGE_MAP[messageType] ? MESSAGE_MAP[messageType] : MESSAGE_MAP.DEFAULT
    };
  }



  render() {
    return (
      <div className="unauthorized-page">
        <div className="error-message">{this.state.message}</div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/share/UnauthorizedPage.jsx